import { Box, styled } from '@planne-software/uni/mui/material';

export const NoteRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '0.5rem',
  borderRadius: '0.25rem',
  background: theme.tokens.colors['color-neutral-softer']!,
}));

export const NoteText = styled('p')(({ theme }) => ({
  margin: 0,
  fontFamily: theme.typography.fontFamily,
  fontSize: '0.8125rem',
  lineHeight: 'normal',
  color: theme.tokens.colors['text-color-neutral-stronger'],
  textAlign: 'center',
}));
